import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton } from '@mui/material';
import {logout} from "../../shared/utils/auth"
import MoreVertIcon from '@mui/icons-material/MoreVert'
import ProfileSettingsDialog from './ProfileSettingsDialog';

export default function BasicMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isProfileOpen, setIsProfileOpen] = React.useState(false);
  const open = Boolean(anchorEl);
  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton onClick={handleMenuOpen} style={{color:"white"}} >
        <MoreVertIcon/>
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => { setIsProfileOpen(true); handleClose(); }}>Профиль</MenuItem>
        <MenuItem onClick={logout}>Выйти</MenuItem>
      </Menu>
      <ProfileSettingsDialog open={isProfileOpen} onClose={() => setIsProfileOpen(false)} />
    </div>
  );
}
